'use client';

import React from 'react';
import { ChevronUp, Mic, Clock } from 'lucide-react';

const QUEUE = [
  { id: 'q-001', text: 'El dueño del negocio de la esquina tiene dos familias en la misma cuadra y ninguna sabe de la otra 🤯', votes: 567, status: 'contando', category: 'Vecinos' },
  { id: 'q-002', text: 'El marido de mi amiga dice que trabaja hasta tarde pero lo vieron en el mall con otra señora comprando ropa de mujer... para él 💅', votes: 445, status: 'proximo', category: 'Familia' },
  { id: 'q-003', text: 'Una famosa influencer de Santiago compra sus propios productos con cuentas falsas para inflar las reseñas ⭐', votes: 389, status: 'proximo', category: 'Famosos' },
  { id: 'q-004', text: 'Una amiga se fue de vacaciones con su "primo" y resulta que el primo tiene el mismo apellido que ella pero no son familia 🤔', votes: 312, status: 'proximo', category: 'Amor' },
  { id: 'q-005', text: 'El presidente del condominio usa los fondos del edificio para pagar el Netflix de su casa 😤', votes: 267, status: 'proximo', category: 'Vecinos' },
];

const categoryColors: Record<string, string> = {
  Amor: 'bg-pink-100 text-pink-700',
  Trabajo: 'bg-blue-100 text-blue-700',
  Familia: 'bg-orange-100 text-orange-700',
  Vecinos: 'bg-green-100 text-green-700',
  Famosos: 'bg-purple-100 text-purple-700',
};

export default function GossipQueue() {
  return (
    <div className="bg-card border border-border rounded-2xl p-5">
      <div className="flex items-center gap-2 mb-5">
        <Clock size={16} className="text-primary" />
        <h3 className="font-bold text-foreground">Próximos Chismes</h3>
        <span className="ml-auto text-xs text-muted-foreground font-medium">Ordenados por votos</span>
      </div>

      <div className="flex flex-col gap-3">
        {QUEUE.map((item, index) => (
          <div
            key={item.id}
            className={`flex items-start gap-3 p-3 rounded-xl border transition-all ${
              item.status === 'contando'
                ? 'bg-primary/8 border-primary/30 ring-2 ring-primary/20' :'bg-muted/30 border-transparent hover:border-border'
            }`}
          >
            {/* Position number */}
            <div className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${
              item.status === 'contando'
                ? 'bg-primary text-white' :'bg-muted text-muted-foreground'
            }`}>
              {item.status === 'contando' ? <Mic size={12} /> : index}
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              {item.status === 'contando' && (
                <div className="flex items-center gap-1.5 mb-1">
                  <span className="text-xs font-bold text-primary live-pulse">📖 Contando ahora</span>
                </div>
              )}
              <p className="text-sm text-foreground leading-snug line-clamp-2">{item.text}</p>
              <div className="flex items-center gap-2 mt-1.5">
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${categoryColors[item.category] || 'bg-gray-100 text-gray-700'}`}>
                  {item.category}
                </span>
              </div>
            </div>

            {/* Vote count */}
            <div className="shrink-0 flex items-center gap-1 text-sm font-bold text-muted-foreground font-tabular">
              <ChevronUp size={14} />
              {item.votes}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}